/**
 * Тип цены/расчета. Соответствует словарю rate_type
 * @property FIXED_PRICE = 1, // Фиксированная цена
 * @property PREPAYMENT_VOLUME = 2, // Цена за объем-предоплата
 * @property UNIT_VOLUME = 3, // За единицу объема,
 * @property RANGE_VOLUME = 4, // За объем из диапазона,
 */

export enum RateTypes {
  FIXED_PRICE = 1, // Фиксированная цена
  PREPAYMENT_VOLUME = 2, // Цена за объем-предоплата
  UNIT_VOLUME = 3, // За единицу объема,
  RANGE_VOLUME = 4, // За объем из диапазона,
}
